import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import { ToastProvider } from './components/Toast';
import Landing from './pages/Landing.js';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import ForgotPassword from './pages/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword.js';
import PublicMenu from './pages/PublicMenu.js';
import Dashboard from './pages/admin/Dashboard.js';
import MenuItems from './pages/admin/MenuItems.js';
import Categories from './pages/admin/Categories.js';
import QRCode from './pages/admin/QRCode.js';
import Settings from './pages/admin/Settings.js';
import Profile from './pages/admin/Profile.js';
import OnlineOrders from './pages/admin/OnlineOrders.js';
import Catering from './pages/admin/Catering.js';
import Setup from './pages/Setup';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="loading-center min-h-screen">
      <div className="loading-spinner"></div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/menu/:slug" element={<PublicMenu />} />
            <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/menu" element={<Protected><MenuItems /></Protected>} />
            <Route path="/admin/categories" element={<Protected><Categories /></Protected>} />
            <Route path="/admin/qr" element={<Protected><QRCode /></Protected>} />
            <Route path="/admin/orders" element={<Protected><OnlineOrders /></Protected>} />
            <Route path="/admin/catering" element={<Protected><Catering /></Protected>} />
            <Route path="/admin/setup" element={<Protected><Setup /></Protected>} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/admin/profile" element={<Protected><Profile /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}